import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Label } from '@independent-software/typeui/controls/Label';

import { AuthContext } from '../../AuthContext';
import { Section, Viewer } from '../../modules';
import { Parametercategory, ParametercategoryFactory, Parameter } from '../../resource/'; 
import { Output } from '../../controls/Output';
import { ListParameters } from '../Parameter';

const ViewParametercategory = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleParameterClick = (parameter: Parameter) => {
    navigate(`/parameters/${parameter.id}`);
  }

  return (
    <Viewer<Parametercategory> 
      auth={auth}
      id={parseInt(id)}
      factory={ParametercategoryFactory}
      canEdit={(item: any) => false}
      canDelete={(item: any) => false}
      onEdit={null}
      onDelete={null}
      content={(parametercategory: Parametercategory) => 
        <>
          <Section dark padded>
            <Header size="h2">{parametercategory.name}</Header>
          </Section>
          <Tabs underlined>
            <Tabs.Pane label="General">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <>
                    <Output label="Name" hint="Parametercategory name">{parametercategory.name}</Output>
                  </>
                  <>
                  </>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>
            <Tabs.Pane label={<span>Parameters <Label size="small">{parametercategory.parameters_count}</Label></span>}>
              <ListParameters parametercategoryId={parametercategory.id} name="parametercategory_parameters" auth={auth} onClick={auth.hasRight('can_view_parameters') && handleParameterClick}/>
            </Tabs.Pane>
          </Tabs>
        </>}>
    </Viewer>
  );
}

export { ViewParametercategory }
